import React from 'react';
import styles from './inputFeedback.module.css';

export const InputFeedbackList = ({ children }) => <ul className={styles.list}>{children}</ul>;
